module.exports = __webpack_public_path__ + "static/media/majors-classroom-university-of-arizona.1d24ae51.jpg";